var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 46.526a11.022 11.022 0 009-3 9.094 9.094 0 0013.5 0 9.094 9.094 0 0013.5 0 11.022 11.022 0 009 3M43.514 40.542a12.456 12.456 0 002.858-3.908A1.5 1.5 0 0045 34.526H3a1.5 1.5 0 00-1.372 2.108A12.91 12.91 0 005.2 41.182",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 34.526V4.06a2.534 2.534 0 00-4.568-1.512L4.542 23.2A1.5 1.5 0 005.8 25.522l16.696-.024M31.262 11.822a1.5 1.5 0 00-2.762.812v15.892h10.752a1.502 1.502 0 001.262-2.312z",
    strokeWidth: 3
  }))));
}
export default SvgBoat;